// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2clYY","col":"styles_col__NQXh0"};